// src/lib/opportunity/formatDepositTypes.ts

import { FORMAT_CALC_PRODUCT_TYPE_WILDCARD } from "./formatCalcLineTypes.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";

export const FORMAT_DEPOSIT_MODES = ["percent", "amount"] as const;
export type FormatDepositMode = (typeof FORMAT_DEPOSIT_MODES)[number];

export const FORMAT_DEPOSIT_MILESTONE_MAX_LEN = 200;

export type FormatDepositRule = {
  id: string;
  organization_id: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  deposit_mode: FormatDepositMode;
  deposit_value: number;
  deposit_milestone_label: string;
  deposit_milestone_subtext: string | null;
  balance_milestone_label: string;
  balance_milestone_subtext: string | null;
  updated_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

export type FormatDepositRuleDef = Pick<
  FormatDepositRule,
  | "deposit_mode"
  | "deposit_value"
  | "deposit_milestone_label"
  | "deposit_milestone_subtext"
  | "balance_milestone_label"
  | "balance_milestone_subtext"
>;

export const DEFAULT_FORMAT_DEPOSIT_RULE: FormatDepositRuleDef = {
  deposit_mode: "percent",
  deposit_value: 25,
  deposit_milestone_label: "Deposit due at signing",
  deposit_milestone_subtext: "Secures scheduling",
  balance_milestone_label: "Final balance due on delivery",
  balance_milestone_subtext: "Remaining balance — due at project delivery",
};

/** Product-specific deposit rule wins; otherwise use the org `*` template. */
export function selectFormatDepositRule(args: {
  rules: FormatDepositRule[];
  productType: string;
}): FormatDepositRuleDef {
  const specific = args.rules.find((r) => r.product_type === args.productType);
  if (specific) return specific;
  const wildcard = args.rules.find((r) => r.product_type === FORMAT_CALC_PRODUCT_TYPE_WILDCARD);
  if (wildcard) return wildcard;
  return DEFAULT_FORMAT_DEPOSIT_RULE;
}
